import { render } from "./Parcours.vue?vue&type=template&id=08b8f14a&scoped=true"
import script from "./Parcours.vue?vue&type=script&lang=js"
export * from "./Parcours.vue?vue&type=script&lang=js"

import "./Parcours.vue?vue&type=style&index=0&id=08b8f14a&lang=scss&scoped=true"

import exportComponent from "/Users/Sacha/PhpstormProjects/landgoedmorrenrun/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b8f14a"]])

export default __exports__